<template>
	<div class="checkInQuery">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav1" id="1">退房确认</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="2">入住确认</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="3">处理历史</mt-tab-item>
        </mt-navbar>
      </div>

      <!-- tab-container -->
      <div class="margin-top-10">
        <mt-tab-container v-model="selected">
          <mt-tab-container-item id="3">
            <!-- 搜索框 -->
            <div class="serachInput bg-fff">
              <div class="serach bg-f5f5f5" style="width: 100%;">
                <input class="bg-f5f5f5 font-size-28" type="text" placeholder="输入姓名／学号" v-model="searchValue" style="width: 100%;">
                <img class="deleteBtn" @click="deletInput()" src="static/images/searchDelete.png" />
                <div class="serachBtn serachBtn1 color-fff margin-left-20 font-size-14px" @click="searchClick()">搜索</div>
              </div>
            </div>
          </mt-tab-container-item>
        </mt-tab-container>
      </div>

    </div>

    <!-- 内容栏 -->
    <!-- <div> -->
      <div v-if="selected == 1" class="scroll-content scroll-content1">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="padding-20 bg-fff margin-top-20" @click="openPage('RoomChangeDetial', item, 4)" v-for="(item, index) in list" :key="index">
            <div class="listBox">
              <img class="thumbnail" :src="Url + item.photoUrl">
              <div class="mesList">
                <div class="title color-333 font-size-14px">{{item.studentName}}</div>
                <p class="color-666 font-size-26 margin-top-8">学号：{{item.studentNo}}</p>
                <p class="color-666 font-size-26 margin-top-8">电话：{{item.studentPhone}}</p>
                <p class="color-666 font-size-26 margin-top-8">原来住址：{{item.oldRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">换房住址：{{item.newRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">申请时间：{{item.createdDt}}</p>
              </div>
              <img class="typeStateBtn" v-if="item.audit2Status == '待审核'" src="static/images/dsh.png"> <!-- 待审核-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已搬出'" src="static/images/ybc.png"> <!-- 已搬出-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已拒绝'" src="static/images/yjj.png"> <!-- 已拒绝-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已取消'" src="static/images/yqx.png"> <!-- 已取消-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已同意'" src="static/images/yty.png"> <!-- 已同意-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已完成'" src="static/images/ywc.png"> <!-- 已完成-->
            </div>
            <div class="border-top handleBoxs">
              <div class="handleBtn color-fff" @click="handleBtn($event, item, 1)">确认搬出</div>
            </div>
          </div>
        </mt-loadmore>
      </div>

      <div v-if="selected == 2" class="scroll-content scroll-content1">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="padding-20 bg-fff margin-top-20" @click="openPage('RoomChangeDetial', item, 5)" v-for="(item, index) in list" :key="index">
            <div class="listBox">
              <img class="thumbnail" :src="Url + item.photoUrl">
              <div class="mesList">
                <div class="title color-333 font-size-14px">{{item.studentName}}</div>
                <p class="color-666 font-size-26 margin-top-8">学号：{{item.studentNo}}</p>
                <p class="color-666 font-size-26 margin-top-8">电话：{{item.studentPhone}}</p>
                <p class="color-666 font-size-26 margin-top-8">原来住址：{{item.oldRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">换房住址：{{item.newRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">申请时间：{{item.createdDt}}</p>
              </div>
              <img class="typeStateBtn" v-if="item.audit2Status == '待审核'" src="static/images/dsh.png"> <!-- 待审核-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已搬出'" src="static/images/ybc.png"> <!-- 已搬出-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已拒绝'" src="static/images/yjj.png"> <!-- 已拒绝-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已取消'" src="static/images/yqx.png"> <!-- 已取消-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已同意'" src="static/images/yty.png"> <!-- 已同意-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已完成'" src="static/images/ywc.png"> <!-- 已完成-->
            </div>
            <div class="border-top handleBoxs">
              <div class="handleBtn color-fff" @click="handleBtn($event, item, 2)">确认搬入</div>
            </div>
          </div>
        </mt-loadmore>
      </div>

      <div v-if="selected == 3" class="scroll-content scroll-content3">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="padding-20 bg-fff margin-top-20" @click="openPage('RoomChangeDetial', item)" v-for="(item, index) in list" :key="index">
            <div class="listBox">
              <img class="thumbnail" :src="Url + item.photoUrl">
              <div class="mesList">
                <div class="title color-333 font-size-14px">{{item.studentName}}</div>
                <p class="color-666 font-size-26 margin-top-8">学号：{{item.studentNo}}</p>
                <p class="color-666 font-size-26 margin-top-8">电话：{{item.studentPhone}}</p>
                <p class="color-666 font-size-26 margin-top-8">原来住址：{{item.oldRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">换房住址：{{item.newRoomName}}</p>
                <p class="color-666 font-size-26 margin-top-8">申请时间：{{item.createdDt}}</p>
              </div>
              <img class="typeStateBtn" v-if="item.audit2Status == '待审核'" src="static/images/dsh.png"> <!-- 待审核-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已搬出'" src="static/images/ybc.png"> <!-- 已搬出-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已拒绝'" src="static/images/yjj.png"> <!-- 已拒绝-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已取消'" src="static/images/yqx.png"> <!-- 已取消-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已同意'" src="static/images/yty.png"> <!-- 已同意-->
              <img class="typeStateBtn" v-if="item.audit2Status == '已完成'" src="static/images/ywc.png"> <!-- 已完成-->
            </div>
          </div>
        </mt-loadmore>
      </div>
      
    </div>

	<!-- </div> -->
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import api from "../fetch/api";


import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {
    Navbar,
    TabItem
  },
  data() {
    return {
      Url: types.URL,
      searchValue: '', //搜索框值
      oldSearchValue: '', //搜索框值old
      selected: '1', //默认当前的tab 页面
      pageNo: 1, //分页
      pageSize: 20, //每次请求的个数
      allLoaded: true,//是否加载完毕
      haveMore: true, //是否有更多数据
      list: [] //数据
    };
  },
  created() {
    this.loaddata();
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    'selected': function() {
      this.list = [];
      this.searchValue = '';
      this.loadTop();
    }
  },
  methods: {
    //一行只能显示4个字 多余的换行
    lineFourText: function (str, num) {
      if (!str) return ''
      let newStr = ''
      for (let index = 0; index < str.length; index++) {
        newStr += str[index]
        if ((index + 1) % num == 0) {
          newStr += '<br />'
        }
      }
      return newStr
    },
    //页面跳转
    openPage: function (pageName, item, type) {
      console.log(item)
      if (item.audit2Status != '待审核') {
        type = '0'
      }
      this.$router.push({name: pageName, query: {pageDate: item, type: type}});
      
    },
    //操作
    handleBtn: function (event, item, type) {
      if(event) {
        event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
      }
      let url = '/wx/changeRoom/audit/doOutRoom' //搬出
      if (type == 2) {
        url = '/wx/changeRoom/audit/doInRoom' //入住
      }

      MessageBox.confirm('确定执行此操作?').then(action => {
        console.log(action)
        if (action == 'confirm') {
          let that = this
          this.$store.dispatch("setLoadingState", true);
          let params = {
            // result: type, //1:同意，2:拒绝
            applyId: item.id
          }
          api.post(url, params)
          .then(res => {
              this.$store.dispatch("setLoadingState", false);
              console.log(res);
              if (res.success) {
                Toast(res.msg);
                that.loadTop();
              }else {
                  Toast(res.msg);
              }

          })
          .catch(error => {
              console.log(error);
          });
          
        }
      });
    },
    //清除input里面的值
    deletInput: function () {
      if (!this.searchValue) {
        return
      }
      this.searchValue = '';
      this.loadTop();
    },
    //搜索按钮
    searchClick: function () {
      if (this.oldSearchValue != this.searchValue) {
        this.loadTop();
      }
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo =1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    more() {
      // 分页查询
      this.pageNo++;
      this.loaddata();
    },
    loaddata(){ //加载数据从vuex中拿数据

      if (this.selected == 1) {
        this.getDatas1(1);
      }
      if (this.selected == 2) {
        this.getDatas1(2);
      }
      if (this.selected == 3) {
        this.getDatas2();
      }

    },
    getDatas1(type) { 
      this.$store.dispatch("setLoadingState", true);
      service
      .findWaitForWy({
        "type": type,  // 1:退房，2:入住
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {

          let listArr = result.rows;
          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    getDatas2() {
      this.$store.dispatch("setLoadingState", true);
      service
      .findAuditHistoryForWy({
        "searchNameOrStudentNo": this.searchValue, //姓名或学号
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          let listArr = result.rows;

          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$serachInput-height: px2rem(100px);
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);

$content1Height: px2rem(70px);
$content2Height: px2rem(200px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.checkInQuery {
  .fixed-content {
    height: 60px !important;
  }
  .scroll-content1 {
    top: calc(#{$content1Height + $cutLine-height}) !important;
  }
  .scroll-content2 {
    top: calc(#{$content2Height}) !important;
  }
  .scroll-content3 {
    top: calc(#{$content2Height}) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.serachInput {
  height: $serachInput-height;
  // position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 px2rem(20px);
  background: #fff;
  //下拉框
  .dropdownBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .dropdown {
      width: px2rem(115px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .serach {
    height: 70%;
    margin-left: px2rem(25px);
    padding: 0 px2rem(10px);
    border-radius: px2rem(10px);
    display: flex;
    justify-content: center;
    // flex: 1;
    align-self: center;
    input {
      height: 100%;
      // flex: 1;
      width: px2rem(220px);
    }
    .deleteBtn {
      width: px2rem(35px);
      height: px2rem(35px);
      align-self: center;
    }
    .serachBtn {
      width: px2rem(80px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
    }
    .serachBtn1 {
      width: px2rem(200px);
    }
  }
}
.gridWarp {
    display: flex;
    padding: px2rem(20px) 0;
    border-bottom: 1px solid #ececec;
    .gridCell:last-child {
      border-right: none;
    }
    .gridCell {
      font-size: 13px;
      line-height: 18px;
      // flex: 1;
      text-align: center;
      // height: $gridCell-height;
      // line-height: $gridCell-height;
      p {
        color: #333;
        font-size: 13px;
      }
      div {
        font-size: 13px;
      }
    }
}
.flex-1 {
  flex: 1;
}
.flex-basis-60 {
  flex-basis: px2rem(110px) !important;
  padding: 0 px2rem(10px);
}
.checkInQuery .tabBtn .navBar .tabBtnNav1 {
  padding: px2rem(30px) 0 !important;
  font-size: 14px;
}
.mobileSelect .content .btnBar .cancel, 
.mobileSelect .content .btnBar .ensure {
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}
.mint-msgbox-btn {
  font-size: 14px;
}
.listBox {
  .bg-f9b625 {
    background: #f9b625;
  }
  display: flex;
  position: relative;
  .typeStateBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: px2rem(124px);
    height: px2rem(102px);
  }
  //缩略图
  .thumbnail {
      width: px2rem(136px);
      height: px2rem(136px);
      margin-right: px2rem(30px);
      border-radius: px2rem(5px);
  }
  //缩略图-长方形
  .thumbnail-max {
      width: px2rem(210px);
      height: px2rem(136px);
      margin-right: px2rem(26px);
      border-radius: px2rem(5px);
  }
  //基本信息栏
  .mesList {
      flex: 1;
      .title {
          display: flex;
          align-items: center;
          flex: 1;
          //列表 标签
          .label {
              flex: none;
              display: inline-block;
              padding: 0 px2rem(15px);
              height: px2rem(32px);
              line-height: px2rem(32px);
              color: #fff;
              border-radius: px2rem(3px);
              margin-right: px2rem(16px);
              margin-left: px2rem(20px);
              font-size: px2rem(22px);
          }
      }
      //标签靠右-标签
      .title-label-right {
          justify-content: space-between;
      }
      p {
          color: #666;
          font-size: px2rem(26px);
          margin-top: px2rem(25px);
      }
  }
}

</style>


// WEBPACK FOOTER //
// RoomChangeQR.vue?794acc19